module.exports = __webpack_public_path__ + "img/NAM.4dfacaf9.gif";